// Registers the device for native push once a real user is logged in.
// Renders nothing; a no-op on the website (isNativeApp() is false there).
// Lives at the router root so notification taps can deep-link anywhere.
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { initPush, isNativeApp } from "@/lib/push";

export default function NativePushBridge() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isNativeApp()) return;
    if (!user || user.demo) return;
    initPush(navigate);
  }, [user, navigate]);

  return null;
}
